// extracted by mini-css-extract-plugin
export var contrastLow = "_2r-1";
export var externalLink = "_2r-2";
export var externalLinkIcon = "_2r-3";
export var link = "_2r-0";
export var linkLabel = "_2r-4";